export function startOfMonth(date) {
  let startOfMonth = new Date(+date);
  startOfMonth.setHours(0, 0, 0, 0);
  startOfMonth.setDate(1);
  return startOfMonth;
}
